import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useReducer, useContext } from 'react';
import { createAction } from 'typesafe-actions';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var SliderValueContext = /*#__PURE__*/createContext({
  activeSlide: 0,
  slides: []
});
var SliderDispatchContext = /*#__PURE__*/createContext(null);
export var SliderProvider = function SliderProvider(_ref) {
  var children = _ref.children,
      settings = _ref.settings;

  var _useReducer = useReducer(reducer, settings),
      slides = _useReducer[0],
      dispatch = _useReducer[1];

  return _jsx(SliderValueContext.Provider, {
    value: slides,
    children: _jsx(SliderDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export function useSliderContext() {
  var sliderContext = useContext(SliderValueContext);

  if (sliderContext === null) {
    throw new Error("Slider isn't available. `useSliderContext` have to be used within SliderContext");
  }

  return sliderContext;
}
export function useSliderDispatchContext() {
  var sliderDispatchContext = useContext(SliderDispatchContext);

  if (sliderDispatchContext === null) {
    throw new Error("Slider isn't available. `useSliderDispatchContext` have to be used within SliderContext");
  }

  return sliderDispatchContext;
}
var SET_ACTIVE = "SET_ACTIVE";
var SWIPED_LEFT = "SWIPED_LEFT";
var SWIPED_RIGHT = "SWIPED_RIGHT";
export var setActive = createAction(SET_ACTIVE)();
export var swipedLeft = createAction(SWIPED_LEFT)();
export var swipedRight = createAction(SWIPED_RIGHT)();

var reducer = function reducer(state, action) {
  switch (action.type) {
    case SET_ACTIVE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeSlide: action.payload.activeSlide
        });
      }

    case SWIPED_LEFT:
      {
        var activeSlide;

        if (state.activeSlide === 0) {
          activeSlide = (state.slides ? state.slides.length : 0) - 1;
        } else {
          activeSlide = state.activeSlide - 1;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeSlide: activeSlide
        });
      }

    case SWIPED_RIGHT:
      {
        var _state$slides;

        var _activeSlide;

        if (state.activeSlide === Number((_state$slides = state.slides) === null || _state$slides === void 0 ? void 0 : _state$slides.length) - 1) {
          _activeSlide = 0;
        } else {
          _activeSlide = state.activeSlide + 1;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeSlide: _activeSlide
        });
      }

    default:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeSlide: 0
        });
      }
  }
};